<ng-container *ngIf="model">
  <div
    *ngIf="borderRadius"
    [ngClass]="{
      rectangle: borderRadius === 'full',
      'rectangle-radius-top': borderRadius === 'top',
      'rectangle-radius-bottom': borderRadius === 'bottom',
      'rectangle-no-radius': borderRadius === 'none'
    }"
  ></div>
  <ol *ngIf="isOrdered" class="rich-text-list ordered-list" [class]="'list' + model?.indent" [style]="styleOrderedList">
    <ng-container *ngTemplateOutlet="li"></ng-container>
  </ol>

  <ul *ngIf="!isOrdered" class="rich-text-list">
    <ng-container *ngTemplateOutlet="li"></ng-container>
  </ul>
</ng-container>

<ng-template #li>
  <li
    [ngSwitch]="item.type"
    *ngFor="let item of model.elements || []"
    [style]="styleLi"
  >
    <ng-container *ngSwitchCase="'rich_text_section'">
      <result-rich-text-section (invoke)="invoke.emit($event)" [model]="item" [highlights]="highlights"> </result-rich-text-section>
    </ng-container>
  </li>
</ng-template>
